import styled from 'styled-components'
import { palette } from '../../Styles/colors'
const color = palette

const Container = styled.div`
  width: 100%;
  border: none;
  margin: 3.5em 0;
`

const PlayerBar = styled.div``

const Progress = styled.div`
  position: relative;
`

const TimeElapsed = styled.div`
  position: absolute;
  border-top: ${color.highlight} 5px solid;
  z-index: 1;

  ${({ elapsed }) => elapsed && `
    width: ${elapsed}%;
  `}
`

const Duration = styled.div`
  width: 100%;
  position: absolute;
  border-top: ${color.darktone} 5px solid;
`

const Controls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1em 1em;
  background-color: ${color.midtone};

  svg {
    stroke-width: 1;
  }

  a {
    color: ${color.base};
  }
`

export {
  Container,
  PlayerBar,
  Progress,
  TimeElapsed,
  Duration,
  Controls
}



// WEBPACK FOOTER //
// ./src/Components/Video/styles.js